import { render, staticRenderFns } from "./ConfiguracaoCobranca.vue?vue&type=template&id=77efcdfc"
import script from "./ConfiguracaoCobranca.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoCobranca.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoCobranca.vue?vue&type=style&index=0&id=77efcdfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports